module.exports = __webpack_public_path__ + "fontello.944d52f718021d6d78cd.eot";


//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/assets/fonts/fontello/font/fontello.eot?38968230
// module id = ../../../../../src/assets/fonts/fontello/font/fontello.eot?38968230
// module chunks = 2